import type { IValuesPrac } from '../../containers/NewPracLocation/valuesTypes';

import InputMask from 'react-input-mask';

import { Field, ErrorMessage, useFormikContext } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { describeUploadError, validateUploadFile } from '../../tools/fileSignature';

export const TestSiteRepresentativeInformation = () => {
    const { t } = useTranslation();
    const { values, handleChange, handleBlur, errors, setFieldTouched, setFieldValue, touched } = useFormikContext<IValuesPrac>();
    const [termsFileError, setTermsFileError] = useState<string | null>(null);

    return (
        <div className="cco_form_row">
            <div className="cco_form_col">
                <h2 className="cco_form_heading">5. {t('NewPracLocation.TestSiteRepresentativeInfo.TestSiteRepresentativeInformation')}</h2>

                <p className="cco_form_subheading">
                {t('NewPracLocation.TestSiteRepresentativeInfo.note')}
                </p>

                <div className="cco_form_wrap">
                    <ul className="cco_form_fieldset">
                        <li className="cco_form_fieldset_item cco_form_fieldset_item_medium">
                            <label htmlFor="ccoFullNameTSR">{t('NewPracLocation.TestSiteRepresentativeInfo.FullName')} <span style={{ color: '#db3a3a' }}>*</span></label>

                            <Field type="text" id="ccoFullNameTSR" name="fullName" />
                            <ErrorMessage component={'div'} name={'fullName'} className="cco_form_message cco_form_message_error" />
                        </li>

                        <li className="cco_form_fieldset_item cco_form_fieldset_item_medium">
                            <label htmlFor="ccoPhoneTSR">{t('NewPracLocation.TestSiteRepresentativeInfo.MobilePhone')} <span style={{ color: '#db3a3a' }}>*</span></label>

                            <InputMask
                                type={'tel'}
                                id={'ccoPhoneTSR'}
                                mask="+1 (999) 999-9999"
                                value={values.phoneNumber}
                                onChange={handleChange('phoneNumber')}
                                onBlur={handleBlur('phoneNumber')}
                            />

                            <ErrorMessage component={'div'} name={'phoneNumber'} className="cco_form_message cco_form_message_error" />
                        </li>

                        <li className="cco_form_fieldset_item cco_form_fieldset_item_medium">
                            <label htmlFor="ccoEmailTSR">{t('NewPracLocation.TestSiteRepresentativeInfo.Email')} <span style={{ color: '#db3a3a' }}>*</span></label>

                            <Field type="email" id="ccoEmailTSR" name="email" />
                            <ErrorMessage name={'email'} component={'div'} className="cco_form_message cco_form_message_error" />
                        </li>

                        <li className="cco_form_fieldset_item cco_form_fieldset_item_medium">
                            <label htmlFor="ccoEmailConfirmationTSR">{t('NewPracLocation.TestSiteRepresentativeInfo.EmailConfirmation')} <span style={{ color: '#db3a3a' }}>*</span></label>

                            <Field type="email" id="ccoEmailConfirmationTSR" name="emailConfirmation" />
                            <ErrorMessage component={'div'} name={'emailConfirmation'} className="cco_form_message cco_form_message_error" />
                        </li>

                        <li className="cco_form_fieldset_item cco_form_fieldset_item_large">
                            <label htmlFor="ccoTCTSR">
                            {t('NewPracLocation.TestSiteRepresentativeInfo.UploadTSR')} <small>{t('NewPracLocation.TestSiteRepresentativeInfo.mb')}</small><span style={{ color: '#db3a3a' }}>*</span>
                            </label>

                            <div className="cco_form_field cco_form_field_0">
                                <div className="cco_form_field_body">
                                    <label className="cco_form_field_label ccs_loader_relative_container" htmlFor="ccoTCTSR">
                                        {(values.termsAndConditions instanceof File && values.termsAndConditions.type.includes('image')) ||
                                        ('string' === typeof values.termsAndConditions &&
                                            values.termsAndConditions &&
                                            !values.termsAndConditions.includes('.pdf')) ? (
                                            <>
                                                <img
                                                    src={
                                                        values.termsAndConditions instanceof File
                                                            ? URL.createObjectURL(values.termsAndConditions)
                                                            : values.termsAndConditions
                                                    }
                                                    onLoad={e => {
                                                        const src = e.currentTarget.src;

                                                        if (src.startsWith('blob:')) URL.revokeObjectURL(src);
                                                    }}
                                                    alt="user profile picture"
                                                />
                                                <span className="cco_form_field_label_caption cco_form_field_label_caption_hover">{t('NewPracLocation.TestSiteRepresentativeInfo.btn')}</span>
                                            </>
                                        ) : (
                                            <>
                                                <span className="cco_form_field_label_icon cco_form_field_label_icon_file"></span>
                                                <span className="cco_form_field_label_caption">{t('NewPracLocation.TestSiteRepresentativeInfo.btn')}</span>
                                            </>
                                        )}
                                    </label>

                                    <Field
                                        type={'file'}
                                        id={'ccoTCTSR'}
                                        accept={'.pdf'}
                                        value={undefined}
                                        name={'termsAndConditions'}
                                        className={'cco_form_field_input'}
                                        onChange={async (event: any) => {
                                            // Capture synchronously — currentTarget is unsafe after an await.
                                            const file = event.currentTarget.files[0];

                                            if (!file) {
                                                return;
                                            }

                                            // Verify the real bytes so a mislabelled .pdf fails here, not after payment.
                                            const result = await validateUploadFile(file, ['pdf']);

                                            if (!result.valid) {
                                                setTermsFileError(describeUploadError(result, t));
                                                setFieldValue('termsAndConditions', null);
                                                setFieldTouched('termsAndConditions', false);
                                                return;
                                            }

                                            setTermsFileError(null);
                                            setFieldTouched('termsAndConditions', true);
                                            setFieldValue('termsAndConditions', file, true);
                                        }}
                                    />
                                </div>

                                <div className="cco_form_field_aside">
                                    {termsFileError && (
                                        <div className="cco_form_message cco_form_message_has_icon cco_form_message_error">
                                            {termsFileError}
                                        </div>
                                    )}
                                    {values.termsAndConditions && !errors.termsAndConditions && touched.termsAndConditions && (
                                        <div className="cco_form_message cco_form_message_has_icon cco_form_message_success">
                                            {values.termsAndConditions instanceof File ? values.termsAndConditions.name : null /* values.termsAndConditions */}
                                        </div>
                                    )}

                                    <ErrorMessage
                                        name={'termsAndConditions'}
                                        component={'div'}
                                        className="cco_form_message cco_form_message_has_icon cco_form_message_error"
                                    />
                                </div>
                            </div>

                            <div className="cco_form_btn cco_form_btn_2">
                                <a href="http://www.nccco.org/PRACtsra" target="_blank">
                                {t('NewPracLocation.TestSiteRepresentativeInfo.download')} 
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
